<template>
	<div>
		<section-header :title="t('common.description')" />
		<ion-textarea
			v-model="description"
			:placeholder="t('note.enter-notes-here')"
			:auto-grow="true"
			:rows="4"
			class="w-full rounded-lg bg-[#eee] px-3 py-2"
		/>
	</div>
</template>

<script setup lang="ts">
	import { IonTextarea } from "@ionic/vue";
	import SectionHeader from "@/components/feature/notes/SectionHeader.vue";
	import { useI18n } from "vue-i18n";

	const { t } = useI18n();
	const description = defineModel<string>();
</script>
